<script>
import { sync } from 'vuex-pathify'
import shopProductOptions from '@/v-shop/mixins/shop-product-options-mixin'

export default {
	lang: 'shop',
	mixins: [shopProductOptions],
	props: {
		product: Object,
		variant: Object,
		ctaText: String,
		customization: Object,
		qtyInputClass: String,
	},
	data() {
		return {
			qty: 1,
			hideStockQtyMessage: this.$srv('shopOptions')?.hideStockQtyMessage,
			hideQytInput: this.$srv('shopOptions')?.hideQytInput,
		}
	},
	computed: {
		ctaIsLoading: sync('shop/ctaIsLoading'),
		outOfStock() {
			return this.variant.stock.availability == 'OutOfStock'
		},
		price() {
			return this.variant.pvPrice.price
		},
		currency() {
			return this.variant.pvPrice.priceConfig.currency.sign
		},
		maxStockQty() {
			let { maxBuyableQty, infiniteQty, qty } = this.variant.stock
			if (maxBuyableQty >= 1) {
				if (infiniteQty) return maxBuyableQty
				else return Math.min(qty, maxBuyableQty)
			} else {
				if (infiniteQty) return 0
				else return qty
			}
		},
	},
	eventsListeners: {
		buyProduct() {
			this.ctaClicked()
		},
	},
	methods: {
		async ctaClicked() {
			return this.$shop.addToCart({
				productId: this.product.id,
				variantId: this.variant.id,
				qty: this.qty,
				sum: true,
				customization: this.customization,
				loading: (v) => (this.ctaIsLoading = v),
				onValidation: ({ validation }) => this.$emit('validation', validation),
			})
		},
	},
}
</script>

<template>
	<div id="product-actions">
		<QtyInput
			v-if="variant.type != 'digital' && !outOfStock && product.buyable && !spoHideQtyInput"
			v-model="qty"
			:max-qty="maxStockQty"
			:min-qty="variant.stock.minBuyableQty"
			:unit-metric="product.unitMetric"
			:pack-metric="product.packMetric"
			:step="variant.metricFactor"
			:class="qtyInputClass"
			:price="price"
			:currency="currency"
			:showCalculatedPrice="!hideCalculatedPrice && product.unitMetric != 'unidad/es'"
		/>
		<ProductStockQtyMessage
			v-if="!hideStockQtyMessage && variant.type != 'digital' && product.buyable"
			:stock="variant.stock"
			:metric="product.unitMetric"
			:metricFactor="variant.metricFactor"
			:packMetric="product.packMetric"
			class="pt-2 grey--text"
			style="font-size: 0.9rem"
		/>
		<div class="pt-4" v-if="!spoHideBuyBtn">
			<Button
				id="product-buy-btn"
				class="full-width py-5 btn-buy"
				color="cta"
				:disabled="outOfStock || !product.buyable"
				:loading="ctaIsLoading"
				@click="ctaClicked"
				large
			>
				<v-icon class="font-0 mr-2">mdi-cart-outline</v-icon>
				<span class="font-2">{{ ctaText || $lang('Comprar ahora') }}</span>
			</Button>
		</div>
	</div>
</template>

